import { render, staticRenderFns } from "./PopsSubFolderClinic.vue?vue&type=template&id=212861a0&scoped=true"
import script from "./PopsSubFolderClinic.vue?vue&type=script&lang=js"
export * from "./PopsSubFolderClinic.vue?vue&type=script&lang=js"
import style0 from "./PopsSubFolderClinic.vue?vue&type=style&index=0&id=212861a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212861a0",
  null
  
)

export default component.exports